export const OngoingVerificationPopupRoutes = {
  ONGOING_VERIFICATION: '/ongoing-verification',
  ONGOING_VERIFICATION_FAILURE: '/ongoing-verification-failure',
  ONGOING_VERIFICATION_SUCCESS: '/ongoing-verification-success'
};
